import { cn } from '@telesoft/lib/web/cn'
import React, { forwardRef, DetailedHTMLProps, HTMLAttributes } from 'react'

type ElementType = 'div' | 'section' | 'main' // Add more HTML tags as needed

interface Props {
  className?: string
  children?: any
  el?: ElementType
  clean?: boolean
}

const Container = forwardRef<HTMLElement, Props>(
  ({ children, className, el = 'div', clean }, ref) => {
    const rootClassName = cn(className, {
      'mx-auto max-w-[1600px] px-4 relative md:px-8 2xl:px-16': !clean,
    })

    const Component: React.ComponentType<
      DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>
    > = el as any

    return (
      <Component ref={ref} className={rootClassName}>
        {children}
      </Component>
    )
  },
)

Container.displayName = 'Container'

export default Container
